// extracted by mini-css-extract-plugin
var _1 = "login-module_forgotText_zBt_f";
var _2 = "login-module_forgotWrapper_Y4pce";
var _3 = "login-module_loginButtonWrapper_Cma_0";
var _4 = "login-module_loginEmailWrap_faMIS";
var _5 = "login-module_loginForm_tIuFI";
var _6 = "login-module_loginPasswordWrap_KrPm4";
var _7 = "login-module_loginSupportLink_OB3pm";
var _8 = "login-module_loginSupportText_ChlXB";
var _9 = "login-module_loginSupportWrapper_s9xj9";
var _a = "login-module_prevbuttonWrapper_gDIzI";
export { _1 as "forgotText", _2 as "forgotWrapper", _3 as "loginButtonWrapper", _4 as "loginEmailWrap", _5 as "loginForm", _6 as "loginPasswordWrap", _7 as "loginSupportLink", _8 as "loginSupportText", _9 as "loginSupportWrapper", _a as "prevbuttonWrapper" }
